<template>
    <div class="project__view__menu w-full p-2 text-sm flex justify-first items-center">
        <div class="inline-flex w-full flex-wrap items-center">
            <div class="view__menus flex items-center flex-start gap-1">
<!--                <div v-if="project.background" :style="{ 'background-image' : 'url('+ project.background.image +')' }" class="flex bg-cover rounded-full w-4 h-4 border"></div>-->
                <h2 class="text-lg font-bold hover:bg-[#a6c5e229] rounded px-3 mr-1 py-1" contenteditable="true" @keypress="saveListTitle($event, project.id)" @blur="saveListTitle($event, project.id)">{{ project.title }}</h2>
                <div class="flex p-2 items-center cursor-pointer rounded hover:bg-[#a6c5e229]" @click="starProject($event, project)">
                    <icon v-if="!!project.star" name="star" class="w-5 h-5 fill-yellow-500 text-yellow-500 hover:fill-none hover:scale-125" />
                    <icon v-else name="star" class="w-5 h-5 text-white hover:text-yellow-500 hover:scale-125" />
                </div>
                <div class="flex p-2 items-center cursor-pointer rounded hover:bg-[#a6c5e229]" @click="visibility_option = !visibility_option">
                    <icon name="all_users" class="w-4 fill-[#ffffff] h-4 mr-[5px]" />
                </div>
                <Link v-for="(option, option_index) in options" class="flex py-2 px-3 items-center cursor-pointer capitalize rounded" :class="{ 'active': view === option.slug }" :href="route('projects.view.'+option.slug, project.slug || project.id)">
                    <icon :name="icons[option_index]" class="w-4 fill-[#ffffff] h-4 mr-[5px]" />
                    {{ __(option.name) }}
                </Link>
            </div>
            <div class="flex items-center flex-start gap-1 ml-auto view__menus">
                <button @click="invite_to_board = true" v-if="this.$page.props.auth.user.role.id == 1" class="flex gap-[5px] bg-indigo-600 h-9 items-center text-white rounded px-3">
                    <icon name="user_plus" class="w-4 h-4 fill-white" />
                    Invite
                </button>
                <button v-if="['board', 'table', 'time_logs'].includes(view)" class="flex pl-4 pr-2 items-center __filter cursor-pointer capitalize rounded hover:bg-[#a6c5e229]" @click="$emit('filterToggle')" :class="{'active': findFilters()}"> <icon name="filter" class="w-4 fill-[#ffffff] h-4 mr-[5px]" />
                    <span>{{ __('Filter') }} </span>
                    <span class="filter_clear" @click="clearFilter($event)">{{ __('Clear All') }} <icon name="close" class="w-4 h-4" /></span>
                </button>
                <button v-if="['board', 'table'].includes(view)" @click="$emit('menuToggle', true)" class="flex px-2 h-8 items-center cursor-pointer capitalize rounded hover:bg-[#a6c5e229]"> <icon name="more-h" class="w-6 fill-[#ffffff] h-6" /></button>
            </div>
        </div>
    </div>
    <div class="absolute w-[340px] z-[200] rounded-[8px] text-sm bg-white shadow overflow-hidden left-[160px]" v-if="visibility_option">
        <div class="flex gap-3 flex-col py-3">
            <div class="flex items-center justify-between gap-1 px-3">
                <div class="flex"></div>
                <div class="flex text-center">
                    {{ __('Change Visibility') }}
                </div>
                <div @click="visibility_option = false" class="flex hover:bg-gray-200 cursor-pointer rounded w-7 h-7 justify-center items-center">
                    <icon class="w-4 h-4" name="close" />
                </div>
            </div>
            <div class="flex flex-col">
                <div class="mb-2 hover:bg-gray-200 dark:hover:bg-gray-700 px-3 cursor-pointer" @click = "changeVisibility('private')">
                    <label class="inline-flex gap-2 items-center"><icon class="w-4 h-4 text-red-500" name="lock" /> Private 
                        <icon class="w-4 h-4" name="tick_check" v-if="project.visibility == '0'"/></label>
                    <p>Only board members can see this board. Workspce admins can close the board or remove members.</p>
                </div>
                <div class="hover:bg-gray-200 dark:hover:bg-gray-700 px-3 cursor-pointer" @click = "changeVisibility('workspace')">
                    <label class="inline-flex gap-2 items-center">
                        <icon class="w-4 h-4" name="briefcase" /> Workspace 
                        <icon class="w-4 h-4" name="tick_check" v-if="project.visibility == '1'"/>
                    </label>
                    <p>All members of the workspace can see and edit this board.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="absolute top-[52px] w-[260px] right-[145px] z-[200] rounded-[8px] bg-white shadow overflow-hidden" v-if="invite_to_board">
        <div class="flex gap-3 flex-col py-3 px-3">
            <div class="flex items-center justify-between gap-1">
                <div class="flex"></div>
                <div class="flex text-center text-black">
                    Invite Members
                </div>
                <div @click="invite_to_board = false" class="flex hover:bg-gray-200 cursor-pointer rounded w-7 h-7 justify-center items-center">
                    <icon class="w-4 h-4" name="close" />
                </div>
            </div>
            <input id="i_w_m_s_u" name="user_search" v-model="user_search" class="border-[2px] px-2 py-1 border-gray-400 rounded-[3px]" placeholder="Search User" />
            <ul class="flex flex-col gap-1 h-48 max-h-48 overflow-y-auto">
                <li v-for="(userObject, user_index) in searchUser(user_search)">
                    <label :for="'uid_'+user_index" class="flex p-2 cursor-pointer hover:bg-gray-200 rounded">
                        <input :id="'uid_'+user_index" class="w-5 ml-1 mr-2" type="checkbox" :checked="project.users.some(user => user.id === userObject.id)" @change="inviteMember($event.target.checked, userObject.id)">
                        <img v-if="userObject.photo_path" :aria-label="userObject.name" :alt="userObject.name" class="w-6 h-6 rounded-full" :src="userObject.photo_path" />
                        <img v-else :aria-label="userObject.name" :alt="userObject.name" class="w-6 h-6 rounded-full" src="/images/user.svg" />
                        <span data-a="" class="p-1" type="button" :tabindex="user_index">{{ userObject.name }}</span>
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import { Link } from '@inertiajs/vue3'
import BoardFilter from "./BoardFilter";
import axios from 'axios'
export default {
    name: 'board-view-menu',
    props: {
        project: Object,
        filters: { required: false },
        view: {
            required: false
        }
    },
    components: {BoardFilter, Icon, Link },
    data() {
        return {
            icons: ['board', 'table', 'dashboard', 'calendar', 'time', 'dashboard'],
            options: [
                {name: 'Board', slug: 'board'},
                {name: 'List', slug: 'table'},
                {name: 'Report', slug: 'dashboard'},
                {name: 'Calendar', slug: 'calendar'},
                {name: 'Time Logs', slug: 'time_logs'},
                {name: 'Test Cases', slug: 'test_cases'},
            ],
            position: {top: 0, left: 0, right: 'inherit'},
            visibility_option: false,
            invite_to_board: false,
            user_search: '',

        }
    },
    created() {
        // console.log(this.$page.props);
    },
    methods: {
        clearFilter(e){
            e.preventDefault();
            e.stopPropagation()
            this.$emit('fClear', true);
        },
        findFilters(){
            const filters = Object.keys(this.filters);
            return filters.some(r=> ['due', 'label', 'user'].includes(r))
        },
        saveListTitle(e, id){
            if (e.keyCode === 13 || e.type === 'blur'){
                e.preventDefault();
                e.target.blur();
                if (e.target.innerText){
                    const title = e.target.innerText.replace(/[^a-zA-Z0-9 _-]/g, "");
                    axios.post(this.route('project.update', id),{ title })
                    this.project.title = title;
                }
            }
        },
        starProject(e, id){
            e.preventDefault();
            axios.post(this.route('json.p.starred.save', id));
            this.project.star = !this.project.star;
        },
        changeVisibility(visibility){
            axios.post(this.route('project.visibility', {'id': this.project.id, 'visibility' : visibility})).then((resp) => {
                this.visibility_option = false
                this.project.visibility = visibility == 'private' ? '0' : '1'
            });
        },
        searchUser(input){
            return this.project.workspace.members.filter(u => u.name.toLowerCase().indexOf(input) > -1 && u.id != this.$page.props.auth.user.id);
        },
        inviteMember(checked, id){
            axios.post(this.route('json.project.member.add'), {project_id: this.project.id, user_id: id}).then((response) => {
                if(response.data){
                    if(checked){
                        this.project.users.push(response.data);
                    }else{
                        const findIndex = this.project.users.findIndex(a => a.id === id);
                        if(findIndex > -1){
                            this.project.users.splice(findIndex, 1);
                        }
                    }
                }
            }).catch((error) => {
                console.log(error)
            })
        },
    }
}
</script>
